module.exports = __webpack_public_path__ + "img/pc_index_map.53b295e2.png";